import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TrafficDeviationTripService } from '@components/traffic-deviations/services/traffic-deviation-trip.service';
import { ActivityPointListItem } from '@components/vehicle/vehicle-trip-info/activity-point-list-item';
import { BladeHeaderComponent } from '@modules/blades/components/blade-header/blade-header.component';
import { Blade, IBladeComponent } from '@modules/blades/models/blade-component';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject, map, Observable, Subject, switchMap, takeUntil } from 'rxjs';

@Component({
    selector: 'app-selected-call',
    templateUrl: 'selected-call.component.html',
    styleUrls: ['selected-call.component.scss'],
    imports: [
      BladeHeaderComponent,
      TranslateModule,
      AsyncPipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@Blade({
  name: 'SelectedCallComponent'
})
export class SelectedCallComponent implements OnInit, OnDestroy, IBladeComponent {
  bladeIndex: number;
  childComponent?: IBladeComponent;
  title?: string;
  isLoading$?: Observable<boolean>;
  isLoadingExtra$?: Observable<boolean>;

  private readonly _router = inject(Router);
  private readonly _route = inject(ActivatedRoute);
  private readonly _tripService = inject(TrafficDeviationTripService);

  protected readonly selectedTrip$ = this._tripService.selectedTrip$;
  protected readonly selectedConnection$ = this._tripService.selectedConnection$;
  protected isSelectedCall$(placeId: string): Observable<boolean> { 
    return this._scope$.pipe(
      switchMap(scope => {
        if(scope === 'CONNECTION') {
          return this.selectedConnection$;
        } else {
          return this.selectedTrip$;
        }
      }),
      map(trip => trip?.selectedPlaceId === placeId),
    ); 
  }
  protected readonly activityPointListItems$: BehaviorSubject<ActivityPointListItem[]> = new BehaviorSubject(undefined);

  public title$: Observable<string|undefined>;
  private _title$: BehaviorSubject<string> = new BehaviorSubject(undefined);

  private _scope$: BehaviorSubject<string> = new BehaviorSubject(undefined);

  private _destroy$ = new Subject<void>();

  constructor() {
    this.title$ = this._title$.asObservable();
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }
  
  ngOnInit() { 
    this._route.paramMap.pipe(
      takeUntil(this._destroy$),
    ).subscribe(params => {
      this._scope$.next(params.get('scope'));
    });

    this._scope$.pipe(
      switchMap(scope => {
        if (scope === 'CONNECTION') {
          return this.selectedConnection$;
        } else {
          return this.selectedTrip$;
        }
      }),
      map(trip => trip?.activityPointListItem),
      takeUntil(this._destroy$),
    ).subscribe(activityPointListItems => this.activityPointListItems$.next(activityPointListItems));
  }

  itemSelected(activityPointListItem: ActivityPointListItem): void {
    if(activityPointListItem.hasDeparted) return;

    if(this._scope$.value === 'CONNECTION') {
      this._tripService.updateSelectedConnectionCall(activityPointListItem.activityPoint);
      this._router.navigate(['', { outlets: { outlet1: null, outlet2: null } }]);      
    } else {
      this._tripService.updateSelectedCall(activityPointListItem.activityPoint);
      this._router.navigate(['', { outlets: { outlet1: null, outlet2: null } }]);
    }
  }

  protected trackByIndex(index: number): number {
 return index; 
}

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}